module.exports = __webpack_public_path__ + "016bd8249e450d3d2a8c4081abd20b89.svg";